/**
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

/**
 * Relative path to the deployment.config.json file relative to the public folder.
 */
export const DEPLOYMENT_CONFIG_FILE_PATH: string = "./deployment.config.json";

/**
 * Client id seach param key in the url.
 */
export const APP_CLIENT_ID_URL_SEARCH_PARAM_KEY: string = "client_id";

/**
 * Users organization seach param key in the url.
 */
export const USERS_ORGANIZATION_URL_SEARCH_PARAM_KEY: string = "org";

/**
 * Error description seach param key in the url.
 */
export const ERROR_DESCRIPTION_URL_SEARCH_PARAM_KEY: string = "error_description";

/**
 * Constant to store the client id in storage.
 */
export const APP_CLIENT_ID_STORAGE_KEY: string = "APP_CLIENT_ID";

/**
 * Constant to store the temporary client id in storage.
 */
export const APP_CLIENT_ID_TEMP_STORAGE_KEY: string = "APP_CLIENT_ID_TEMP";

/**
 * Constant to store the organization in storage.
 */
export const USERS_ORGANIZATION_STORAGE_KEY: string = "ORGANIZATION";

/**
 * Constant to store the temporary organization in storage.
 */
export const USERS_ORGANIZATION_TEMP_STORAGE_KEY: string = "ORGANIZATION_TEMP";

/**
 * Constant to store the base url in storage.
 */
export const APP_BASE_URL_STORAGE_KEY: string = "APP_BASE_URL";

/**
 * Constant to store the state in storage.
 */
export const APP_STATE_STORAGE_KEY: string = "APP_STATE";

/**
 * Atribute consent denied error description.
 */
export const USER_DENIED_ATTRIBUTE_CONSENT_ERROR_DESCRIPTION: string = "User denied the consent";

/**
 * Logout consent denied error description.
 */
export const USER_DENIED_LOGOUT_CONSENT_ERROR_DESCRIPTION: string = "End User denied the logout request";

/**
 * Generic logout error description.
 */
export const GENERIC_LOGOUT_ERROR_DESCRIPTION: string = "Logout error";

/**
 * Asgardeo sign up URL.
 */
export const ASGARDEO_SIGN_UP_FALLBACK_URL: string = "https://asgardeo.io/signup";

/**
 * UTM source to track users signing in to Asgardeo via Try It.
 */
export const ASGARDEO_TRY_IT_UTM_SOURCE: string = "tryit";

/**
 * App Paths.
 */
export const PATHS: {
    ROOT: string;
} = Object.freeze({
    ROOT: "/"
});
